/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".happ-symbol[_ngcontent-%COMP%]{font-size:21px;position:relative;top:-2px;margin:auto 5px auto auto}[_nghost-%COMP%]     .mat-form-field-underline{background-color:rgba(63,60,60,.45)!important}[_nghost-%COMP%]   [_ngcontent-%COMP%]::-webkit-input-placeholder{color:red;transition:opacity 250ms ease-in-out}"];
export { styles as styles };
